<template>
  <div id="app">
    <HovedLinjen /> <!-- Placer headeren -->
    <HomePage />
    <router-view /> <!-- Dette viser din sideindhold -->
    <DetMedSmåt /> <!-- Placer footeren -->
  </div>
</template>

<script>
import HovedLinjen from './components/HovedLinjen.vue'
import DetMedSmåt from './components/DetMedSmåt.vue'
import HomePage from './components/HomePage.vue'

export default {
  name: 'App',
  components: {
    HovedLinjen,   // Brug de korrekte komponentnavne her
    DetMedSmåt,
    HomePage
  }
}
</script>

<style>
/* Globale stilarter */
</style>